function BottomSection() {
  return <div id="bottom-section"></div>
}

export default BottomSection
